<template>
  <form ref="form" class="form-register" @submit.prevent novalidate>
    <header class="form-header">
      <h2 class="form-header__subtitle">Insira os dados cadastrais</h2>
    </header>

    <div class="form-content">
      <div class="row">
        <FormControlInput
          class="col-12"
          icon="user"
          ref="name"
          v-model.trim="items.name"
          label="Nome completo"
          id="name"
          name="name"
          data-vv-as="nome completo"
          v-validate="'required'"
          :valid="!vErrors.has('name') && fields.name && fields.name.dirty && fields.name.valid"
          :error="vErrors.collect('name')"
        />
      </div>

      <div class="row">
        <FormControlMask
          class="col-6"
          v-model="items.document_number"
          type="tel"
          ref="document_number"
          label="CPF"
          id="document_number"
          name="document_number"
          data-vv-as="CPF"
          v-validate="{ required: true, regex: /\d{11}/ }"
          mask="###.###.###-##"
          :valid="
            !vErrors.has('document_number') &&
              fields.document_number &&
              fields.document_number.dirty &&
              fields.document_number.valid
          "
          :error="vErrors.collect('document_number')"
        />

        <FormControlInput
          class="col-6"
          v-model="items.rg"
          label="RG"
          id="rg"
          name="rg"
          ref="rg"
          data-vv-as="RG"
          v-validate="'required'"
          :valid="fields.rg && fields.rg.valid"
          :error="vErrors.collect('rg')"
        />
      </div>

      <div class="row">
        <FormControlMask
          class="col-6"
          v-model="items.birth"
          type="tel"
          label="Data de Nascimento"
          id="birth"
          name="birth"
          ref="birth"
          data-vv-as="data de nascimento"
          v-validate="'required|date_format:dd/MM/yyyy'"
          :masked="true"
          mask="##/##/####"
          :valid="!vErrors.has('birth') && fields.birth && fields.birth.dirty && fields.birth.valid"
          :error="vErrors.collect('birth')"
        />

        <FormControlSelect
          class="col-6"
          v-model="items.gender"
          :options="gender"
          :value="items.gender"
          label="Sexo"
          id="gender"
          name="gender"
          ref="gender"
          data-vv-as="sexo"
          v-validate="'required'"
          :valid="
            !vErrors.has('gender') && fields.gender && fields.gender.dirty && fields.gender.valid
          "
          :error="vErrors.collect('gender')"
        />
      </div>

      <div class="row">
        <FormControlMask
          v-model="items.mobile"
          id="mobile"
          type="tel"
          class="col-6"
          label="Celular"
          data-vv-as="celular"
          name="mobile"
          ref="mobile"
          icon="phone-alt"
          mask="(##) #####-####"
          v-validate="'required'"
          :valid="
            !vErrors.has('mobile') && fields.mobile && fields.mobile.dirty && fields.mobile.valid
          "
          :error="vErrors.collect('mobile')"
        />

        <FormControlInput
          v-model="items.email"
          id="email"
          type="email"
          name="email"
          ref="email"
          class="col-6"
          label="E-mail"
          data-vv-as="e-mail"
          icon="envelope"
          v-validate="'required|email'"
          :valid="!vErrors.has('email') && fields.email && fields.email.dirty && fields.email.valid"
          :error="vErrors.collect('email')"
        />
      </div>

      <div class="row">
        <FormControlMask
          @blur="searchCep"
          v-model="items.address.zipcode"
          id="zipcode"
          ref="address.zipcode"
          type="tel"
          name="zipcode"
          class="col-3"
          label="CEP"
          data-vv-as="CEP"
          mask="#####-###"
          icon="map-marker-alt"
          v-validate="'required'"
          :valid="fields.zipcode && fields.zipcode.valid"
          :error="vErrors.collect('zipcode')"
        />

        <FormControlInput
          v-model="items.address.street"
          :value="items.address.street"
          id="street"
          ref="address.street"
          type="text"
          name="street"
          class="col-8"
          label="Endereço"
          data-vv-as="endereço"
          v-validate="'required'"
          :valid="fields.street && fields.street.valid"
          :error="vErrors.collect('street')"
        />

        <FormControlInput
          v-model="items.address.number"
          id="number"
          ref="address.number"
          type="text"
          name="number"
          class="col-2"
          label="Número"
          data-vv-as="número"
          v-validate="'required'"
          :valid="
            !vErrors.has('number') && fields.number && fields.number.dirty && fields.number.valid
          "
          :error="vErrors.collect('number')"
        />
      </div>

      <div class="row">
        <FormControlInput
          v-model="items.address.complementary_address"
          id="complementary_address"
          ref="address.complementary_address"
          type="text"
          name="complementary_address"
          class="col-6"
          label="Complemento (opcional)"
          data-vv-as="complemento"
          :valid="items.address.complementary_address"
          :error="vErrors.collect('complementary_address')"
        />

        <FormControlInput
          v-model="items.address.neighborhood"
          :value="items.address.neighborhood"
          id="neighborhood"
          ref="address.neighborhood"
          type="text"
          name="neighborhood"
          class="col-6"
          label="Bairro"
          data-vv-as="bairro"
          v-validate="'required'"
          :valid="fields.neighborhood && fields.neighborhood.valid"
          :error="vErrors.collect('neighborhood')"
        />
      </div>

      <div class="row">
        <FormControlInput
          v-model="items.address.city"
          :value="items.address.city"
          ref="address.city"
          id="city"
          name="city"
          type="text"
          class="col-6"
          label="Cidade"
          data-vv-as="cidade"
          v-validate="'required'"
          :valid="fields.city && fields.city.valid"
          :error="vErrors.collect('city')"
        />

        <FormControlSelect
          v-model="items.address.state"
          :value="items.address.state"
          ref="address.state"
          id="state"
          name="state"
          type="text"
          class="col-6"
          label="Estado"
          data-vv-as="estado"
          :options="states"
          v-validate="'required|excluded:Estado'"
          :valid="fields.state && fields.state.valid"
          :error="vErrors.collect('state')"
        />
      </div>

      <div v-if="maintainers.length" class="row">
        <FormControlSelect
          v-model="items.maintainer"
          :value="items.maintainer"
          ref="maintainer"
          id="maintainer"
          name="maintainer"
          type="text"
          class="col-12"
          label="Mantenedora"
          data-vv-as="mantenedora"
          :options="maintainers"
          v-validate="'required|excluded:Mantenedora'"
          :valid="fields.maintainer && fields.maintainer.valid"
          :error="vErrors.collect('maintainer')"
        />
      </div>

      <div class="row">
        <FormControlCheckbox
          v-model="items.terms"
          class="col-12"
          id="terms"
          name="terms"
          ref="terms"
          data-vv-as="termos"
          label="Aceite os termos de adesão às Condições Gerais do Contrato de Gestão de Créditos"
          link="https://valesaudesempre.com.br/condicoes-gerais.pdf"
          linkTitle="Clique aqui para visualizar os termos"
          v-validate="'required'"
          :valid="fields.terms && fields.terms.valid"
          :error="vErrors.collect('terms')"
        />
      </div>

      <div v-if="maintainers.length" class="row">
        <FormControlCheckbox
          v-model="items.billing_terms"
          class="col-12"
          id="billing_terms"
          ref="billing_terms"
          name="billing_terms"
          data-vv-as="termos de cobrança"
          label="Autorizo o desconto da mensalidade do Cartão Vale Saúde Sempre na minha folha de pagamento."
          v-validate="'required'"
          :valid="fields.billing_terms && fields.billing_terms.valid"
          :error="vErrors.collect('billing_terms')"
        />
      </div>

      <div class="row align-center">
        <Button
          :disabled="!formValid || !items.terms"
          @click.native="showResume = true"
          type="button"
          >Continuar</Button
        >
      </div>

      <div v-if="vErrors.items.length" class="row align-center control-error">
        <p>Um ou mais campos não foram preenchidos corretamente. Por favor, verifique.</p>
      </div>
    </div>

    <Modal class="dd-m-resume" v-show="showResume && !vErrors.items.length">
      <div class="dd-m-resume-content">
        <h3>Resumo</h3>
        <h4>
          Confirme os dados antes de prosseguir
        </h4>
        <div class="dd-m-resume-content__block">
          <p><span>Nome completo:</span> {{ items.name }}</p>
          <p><span>CPF:</span> {{ items.document_number | cpf }}</p>
          <p><span>RG:</span> {{ items.rg }}</p>
          <p><span>Nascimento:</span> {{ items.birth }}</p>
          <p><span>Sexo:</span> {{ items.gender }}</p>
          <p><span>Celular:</span> {{ items.mobile | mobile }}</p>
          <p><span>E-mail:</span> {{ items.email }}</p>
          <p><span>CEP:</span> {{ items.address.zipcode | cep }}</p>
          <p><span>Endereço:</span> {{ items.address.street }}, {{ items.address.number }}</p>
          <p><span>Bairro:</span> {{ items.address.neighborhood }}</p>
          <p><span>Cidade:</span> {{ items.address.city }}, {{ items.address.state }}</p>
          <p v-if="items.maintainer"><span>Mantenedora: </span> {{ items.maintainer | cnpj }}</p>
        </div>

        <div class="row align-center">
          <Button class="button--option" @click.native="showResume = false" type="button">
            Editar dados
          </Button>

          <Button
            :disabled="!formValid || !items.terms"
            type="button"
            @click.native="doValidRegister"
          >
            Continuar
          </Button>
        </div>
      </div>
    </Modal>
  </form>
</template>

<script>
import cep from 'cep-promise';
import FormControlInput from '../control/FormControlInput.vue';
import FormControlMask from '../control/FormControlMask.vue';
import FormControlCheckbox from '../control/FormControlCheckbox.vue';
import FormControlSelect from '../control/FormControlSelect.vue';
import Button from '../../buttons/Button.vue';
import statesJson from '../../../data/states.json';
import genderJson from '../../../data/gender.json';
import Modal from '../../modals/Modal.vue';
import Storage from '../../../services/storage';
import { doRegister } from '../../../services/internal-register';
import { ApiError } from '../../../services/error-handler';

export default {
  name: 'FormInternalRegister',
  components: {
    FormControlInput,
    FormControlMask,
    FormControlCheckbox,
    FormControlSelect,
    Button,
    Modal
  },
  data() {
    return {
      showResume: false,
      programId: this.$route.params.programId,
      states: statesJson,
      gender: genderJson,
      items: {
        gender: null,
        address: {
          state: null
        },
        maintainer: null,
        terms: null,
        billing_terms: null
      },
      errors: {
        address: {
          zipcode: ''
        }
      },
      maintainers: []
    };
  },
  mounted() {
    const program = Storage.get('program');

    if (!program.maintainers) {
      return;
    }

    Object.entries(program.maintainers).forEach(value => {
      const [slug, name] = value;
      this.maintainers.push({ name, slug });
    });
  },
  computed: {
    formValid() {
      return Object.keys(this.fields).every(field => {
        return this.fields[field] && this.fields[field].valid;
      });
    }
  },
  methods: {
    doValidRegister() {
      if (this.vErrors.items.length) {
        return;
      }

      this.$root.$emit('button-loading', true);

      doRegister(this.programId, this.items)
        .then(() => {
          Storage.clear();
          this.$router.push({
            name: 'success-internal-register'
          });
        })
        .catch(e => {
          this.$toaster.error(e.message);

          if (e instanceof ApiError && e.status === 422) {
            e.fields.forEach(error => {
              // TODO: Refatorar para permitir uso de nome/id ao invés de refs
              const field = this.$refs[error.name];

              if (field) {
                this.$validator.errors.add({
                  id: field.id,
                  field: field.name,
                  msg: error.message,
                  scope: this.$options.scope
                });
              }
            });
          }

          this.showResume = false;
        })
        .finally(() => this.$root.$emit('button-loading', false));
    },
    searchCep(e) {
      if (e) {
        this.disableAddress(true);

        cep(this.items.address.zipcode)
          .then(response => {
            this.items.address = response;
            this.items.address.zipcode = e;
            this.items.address.number = null;

            this.disableAddress(false);
          })
          .catch(() => {
            this.disableAddress(false);
          });
      }
    },
    disableAddress(state) {
      if (state === true) {
        return Object.entries(this.$refs).forEach(item => {
          if (item[0].includes('address')) {
            item[1].$el.querySelector('.control-input').classList.add('disabled');
            item[1].$el.querySelector('.control-input').setAttribute('readonly', 'readonly');
          }
        });
      }

      return Object.entries(this.$refs).forEach(item => {
        if (item[0].includes('address')) {
          item[1].$el.querySelector('.control-input').classList.remove('disabled');
          item[1].$el.querySelector('.control-input').removeAttribute('readonly', 'readonly');
        }
      });
    }
  }
};
</script>

<style lang="scss">
.form-header {
  text-align: center;
  margin-bottom: 24px;
  color: var(--color-positive-normal);

  &__title {
    margin: 0;
    margin-bottom: 8px;
    font-weight: 700;
    text-transform: uppercase;
  }

  &__subtitle {
    margin: 0;
    font-weight: 400;

    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
}

.form-footer {
  @extend .form-header;

  &__subtitle {
    @extend .form-header__subtitle;
  }
}

.dd-m-resume-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  height: 100%;
  padding: 24px 32px;
  background-color: #fff;

  @media (min-width: 1024px) {
    position: relative;
    max-width: 560px;
    box-shadow: 0 8px 24px rgba(#000, 0.1);
    border-radius: 16px;
  }

  &__block {
    background-color: #f1f1f1;
    padding: 12px;
    margin-bottom: 24px;
    border-radius: 8px;
    font-size: 14px;
    height: 320px;
    overflow-y: auto;

    div {
      margin-top: 16px;
    }

    p {
      margin: 0;

      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }

    span {
      color: #999;
    }
  }

  h3 {
    margin: 0;
    margin-bottom: 8px;
    text-align: center;
    font-weight: 400;
    font-size: 24px;
  }

  h4 {
    margin: 0;
    margin-bottom: 24px;
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    /*color: #999;*/
  }

  .button {
    margin: 8px;
  }
}

.form-content {
  &:not(:last-child) {
    margin: 32px 0;
  }
}

.control-wrap label {
  margin: 8px auto 24px;
  display: flex;
  align-items: center;
  font-weight: 600;
  color: var(--color-positive-normal);
}
</style>
